import type { JSX } from 'react';
import { selectSystemTenantConfig, selectSystemTenantConfigurationIsLoading } from '@/features/system/store/selectors';
import { DynamicLogo } from '@/domains/auth/layouts/AuthPageContainer/AuthPageContainer.styles';
import { Logo } from '@/layouts/Header/components/Logo/Logo';
import { useSelector } from '@/store/hooks';

interface TenantLogoProps {
  fallbackLogo: JSX.Element;
  isLoginPage?: boolean;
}

export const TenantLogo = ({ isLoginPage, fallbackLogo }: TenantLogoProps) => {
  const tenantConfiguration = useSelector(selectSystemTenantConfig);
  const tenantConfigurationIsLoading = useSelector(selectSystemTenantConfigurationIsLoading);

  if (tenantConfigurationIsLoading) return null;

  if (
    isLoginPage &&
    tenantConfiguration?.pages?.login?.loginLogo &&
    checkIsLogoValid(tenantConfiguration.pages.login.loginLogo)
  ) {
    return <Logo logoIcon={<DynamicLogo data-testid="tenantLogo" src={tenantConfiguration.pages.login.loginLogo} />} />;
  }

  if (tenantConfiguration?.logo && checkIsLogoValid(tenantConfiguration.logo)) {
    return <Logo logoIcon={<DynamicLogo data-testid="tenantLogo" src={tenantConfiguration.logo} />} />;
  }

  return fallbackLogo;
};

const checkIsLogoValid = (logoUrl: string) => {
  return /^https?:\/\/.*\/.*\.(png|svg|jpeg)$/.test(logoUrl);
};
